export default "__VITE_ASSET__C$t4IeC$__"